import axios from "@/plugins/axios";

let url = "/api/v1/person/expo/programs";

export const programs = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
};

export default programs;
